import React from "react"
import { useLocation } from  'react-router-dom'
import { Navbar, Nav,NavDropdown } from "react-bootstrap"
import './css/componentsStyling.css'

const Header = () => {
//assigning location variable
const location = useLocation();

//destructuring pathname from location
const { pathname } = location;

//Javascript split method to get the name of the path in array
const splitLocation = pathname.split("/");  return (
    <header>
<Navbar collapseOnSelect expand="lg">
  <Navbar.Brand href="#">
  <img
        src="/logo_cts_fondo_transparente.png"
        width="159"
        height="65"
        className="d-inline-block align-top"
        alt="Cabo Travel Solutions Logo"
      />
  </Navbar.Brand>
      {/*<Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">   
    <Nav className="mr-auto justify-content-end" style={{ flex: 1}} >
    <Nav.Link className="navLink" href="https://www.luba-ponce.reserve-cabotravelsolutions.com/transportations">Home</Nav.Link>
      <Nav.Link className="navLink" href="https://www.luba-ponce.reserve-cabotravelsolutions.com/transportations">About Us</Nav.Link>
      <NavDropdown className="navLink" title="Services" id="basic-nav-dropdown">
           <NavDropdown.Item href="https://www.luba-ponce.reserve-cabotravelsolutions.com/transportations">Destinations</NavDropdown.Item>
           <NavDropdown.Item href="https://www.luba-ponce.reserve-cabotravelsolutions.com/transportations">Our Vehichles</NavDropdown.Item>
      </NavDropdown>
      <Nav.Link className="navLink" href="https://www.luba-ponce.reserve-cabotravelsolutions.com/transportations">Reserve</Nav.Link>
    </Nav>
  </Navbar.Collapse> */}
</Navbar>    
</header>
  )
}

export default Header
